var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1650px"}},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"合同管理"}},[_c('OnsiteCustomer',{ref:"OnsiteCustomer"})],1),_c('TabPane',{attrs:{"label":"负责在审件"}},[_c('LoanList',{ref:"LoanList"})],1),_c('TabPane',{attrs:{"label":"协助在审件"}},[_c('HelpLoanList',{ref:"HelpLoanList"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }